'use strict';

const Reflux = require('@muzzylane/reflux');
const Promise = require('bluebird');
const find = require('lodash/find');
const reject = require('lodash/reject');

const CollaboratorActions = require('../actions/CollaboratorActions');
const ForgeError = require('../util/error');
const ErrorConsts = require('../constants/error');
const SignInActions = require('../actions/sign_in_actions');

let allPCollaborators = {};
let action = {};
let error = null;

const CollaboratorStore = Reflux.createStore({
    listenables: [CollaboratorActions, SignInActions],
    init: function() {},

    resetState: function() {
        allPCollaborators = {};
    },

    onSignOutCompleted: function(res) {
        this.resetState();
        this.emitStatus();
    },

    onSignOutFailed: function(err) {
        console.warn(err);
        this.resetState();
        this.emitStatus();
    },

    getState: function() {
        return {
            // initialized: initialized, //not applicable
            pCollaborators: allPCollaborators,
            action: action,
            error: error
        }
    },

    getStateProject: function(projectID) {
        const collabsForP = allPCollaborators[projectID] || {};

        return {
            initialized: collabsForP.initialized,
            pCollaborators: collabsForP.pCollaborators,
            action: action,
            error: error
        }
    },

    getStateProjectUser: function(projectID, userID) {
        const collabsForP = allPCollaborators[projectID] || {};
        return {
            initialized: collabsForP.initialized,
            pCollab: find(collabsForP.pCollaborators, {id: userID}),
            action: action,
            error: error
        }
    },

    emitStatus: function() {
        this.trigger(this.getState());
        action = {};
        error = null;
    },

    onError: function(actionId, err) {
        action = { id: actionId };

        if (err.status){
            switch (err.status){
                case 422:
                    action.error = new ForgeError({message: err.responseText});
                    break;
                default:
                    action.error = new ForgeError({message: ErrorConsts.INTERNAL_GENERAL, stack: err.responseText || null});
                    break;
            }
        }
        else {
            action.error = err;
        }

        this.emitStatus();
    },

    onSetProjectPermissionCompleted: function(actionId, projectID, newUserRecords) {
        action = { id: actionId };

        if (!allPCollaborators[projectID]) { //this probably shouln't ever be needed
            allPCollaborators[projectID] = { initialized: true, pCollaborators: [] };
        }

        Object.keys(newUserRecords).forEach(newUserId => {
            allPCollaborators[projectID].pCollaborators = reject(allPCollaborators[projectID].pCollaborators, { id: parseInt(newUserId, 10) }); //remove any old record

            if (Object.keys(newUserRecords[newUserId]).length !== 0) { //deletion API will return an object of the format { [userId]: {} }, empty object indicates deletion
                allPCollaborators[projectID].pCollaborators.push(newUserRecords[newUserId]);
            }
        });

        this.emitStatus();
    },

    onSetProjectPermissionFailed: function(actionId, projectID, err) {
        console.warn("onSetProjectPermissionFailed:", actionId, projectID, err);
        action = { id: actionId, error: err };
        this.emitStatus();

        // this.onError(actionId, err);
    },

    onDeleteProjectPermissionCompleted: function(actionId, projectID, newUserRecords) {
        this.onSetProjectPermissionCompleted(actionId, projectID, newUserRecords);
    },

    onDeleteProjectPermissionFailed: function(actionId, projectID, err) {
        console.warn("onDeleteProjectPermissionFailed:", actionId, projectID, err);
        this.onError(actionId, err);
    },

    onGetProjectCollabsCompleted: function(actionId, projectID, res) {
        // console.log("onGetProjectCollabsCompleted: ", actionId, projectID, res);
        action = { id: actionId };

        if (allPCollaborators[projectID]) {
            delete allPCollaborators[projectID];
        }

        allPCollaborators[projectID] = {}
        allPCollaborators[projectID].initialized = true;
        allPCollaborators[projectID].pCollaborators = res;

        this.emitStatus();
    },

    onGetProjectCollabsFailed: function(actionId, projectID, err) {
        console.warn("onGetProjectCollabsFailed: ", actionId, projectID, err);
        this.onError(actionId, err);
    },

    onGetChannelProjectsCollabsCompleted: function(actionId, collabsObj) {
        // console.log("onGetChannelProjectsCollabsCompleted: ", actionId, collabsObj);
        action = { id: actionId };

        Object.keys(collabsObj).forEach(projectId => {
            if (allPCollaborators[projectId]) {
                delete allPCollaborators[projectId];
            }

            allPCollaborators[projectId] = {}
            allPCollaborators[projectId].initialized = true;
            allPCollaborators[projectId].pCollaborators = collabsObj[projectId];
        });

        this.emitStatus();
    },

    onGetChannelProjectsCollabsFailed: function(actionId, err) {
        console.warn("onGetChannelProjectsCollabsFailed: ", actionId, err);
        this.onError(actionId, err);
    },
});

module.exports = CollaboratorStore;
